// API client — Performance & Snapshots mandat (Lot M5).
const BASE = process.env.REACT_APP_BACKEND_URL || "";

async function req(path, opts = {}) {
  const { method = "GET", body } = opts;
  const res = await fetch(`${BASE}${path}`, {
    method,
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) {
    const detail = data?.detail;
    const code = typeof detail === "object" ? detail?.code : undefined;
    const msg = typeof detail === "string" ? detail
             : detail?.message || code || `HTTP ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    err.code = code;
    err.detail = detail;
    throw err;
  }
  return data;
}

export const mandatePerformance = {
  summary:   (mandateId) => req(`/api/mandates/${mandateId}/performance`),
  list:      (mandateId, includeSuperseded = false) =>
    req(`/api/mandates/${mandateId}/performance/snapshots?include_superseded=${includeSuperseded ? 1 : 0}`),
  detail:    (mandateId, snapshotId) =>
    req(`/api/mandates/${mandateId}/performance/snapshots/${snapshotId}`),
  create:    (mandateId, payload) =>
    req(`/api/mandates/${mandateId}/performance/snapshots`,
        { method: "POST", body: payload }),
  supersede: (mandateId, snapshotId, payload) =>
    req(`/api/mandates/${mandateId}/performance/snapshots/${snapshotId}/supersede`,
        { method: "POST", body: payload }),
  updateFrequency: (mandateId, days) =>
    req(`/api/mandates/${mandateId}/performance/review-frequency`,
        { method: "PATCH", body: { days } }),
};

export default mandatePerformance;
